import { Box, Stack, Typography } from "@mui/material";
import { SmallModal } from "../../components/SmallModal";
import { useParameter } from "../../hooks/useParameters";
import { ShowMore } from "../../molecules/ShowMore";
import FormTimestamp from "../../molecules/FormTimestamp";

type ParameterDetailModalProps = {
  open: boolean;
  onClose: () => void;
  parameterId: string;
};

export const ParameterDetailModal = (props: ParameterDetailModalProps) => {
  const { open, onClose, parameterId } = props;
  const { data: parameter, isLoading } = useParameter(parameterId);

  return (
    <SmallModal open={open} onClose={onClose} title="Parameter" isLoading={isLoading}>
      <Stack gap="10px">
        <Box width="100%" display="flex" alignItems="center">
          <Typography variant="h3" sx={{ width: "60px" }}>
            Name
          </Typography>
          <Typography variant="body2">{parameter?.name}</Typography>
        </Box>
        <Box width="100%" display="flex" alignItems="center">
          <Typography variant="h3" sx={{ width: "60px" }}>
            Type
          </Typography>
          <Typography variant="body2">{parameter?.field_type}</Typography>
        </Box>
        {parameter?.description && (
          <>
            <Typography variant="h3">Description</Typography>
            <ShowMore description={parameter?.description} richText />
          </>
        )}
        {parameter && (
          <FormTimestamp
            padding="0px"
            direction="row"
            createdBy={parameter.created_by}
            updatedBy={parameter.updated_by}
            createdOn={parameter.created_on}
            updatedOn={parameter.updated_on}
          />
        )}
      </Stack>
    </SmallModal>
  );
};
